import React from 'react';
import { Accordion } from 'flowbite-react';

import classNames from 'classnames';
import { useGetMeetingByIdQuery, useGetSampleAssessmentByMeetingIdQuery } from 'src/hooks/meeting.hooks';
import { Loader } from 'ui';
import { difficultyNumberToTextMapping } from 'shared-utils';
import { QuestionDifficulty, QuestionTypes } from 'types';
import { useParams } from 'react-router-dom';
import StudentEditor from 'src/components/quiz/Editor';

const ShowSampleAssessment = () => {
	const { id: meetingId } = useParams();

	const { data: meeting, isLoading: meetingLoading } = useGetMeetingByIdQuery(String(meetingId));

	const { data: sampleAssessment, isLoading } = useGetSampleAssessmentByMeetingIdQuery(meetingId as string);

	if ((!sampleAssessment || sampleAssessment.sampleAssessment?.length === 0) && !isLoading && !meetingLoading)
		return (
			<div className="text-large mt-8 flex items-center justify-center text-center font-medium">
				No sample assessment found for this meeting!
			</div>
		);
	if (isLoading || meetingLoading) return <Loader />;
	return (
		<div className="m-8 pt-2">
			<div className="flex gap-8 text-lg">
				<div>Round: {meeting?.meeting.round?.title}</div>
				<div>Duration: {meeting?.meeting?.duration} mins</div>
			</div>
			<div className="mb-8">
				{sampleAssessment?.sampleAssessment?.map((a, index) => {
					const difficulty = a
						?.map(assessment => assessment?.question?.difficulty)
						.sort((a, b) => Number(a) - Number(b));
					const uniqueDifficulty = [...new Set(difficulty)];
					return (
						a?.length && (
							<div key={index}>
								<div className={classNames('flex gap-8 border-b-2 border-[#1C1C28] pb-2 mt-8 border-t-2 p-2 text-lg')}>
									<div className="font-extrabold">Round Type: {a[0].roundType}</div>
									<div className="">
										Maximum No. of Questions Posssible : <span className="font-extrabold">{a?.length}</span>
									</div>

									<div className="">
										Difficulty of questions present:{' '}
										<span>
											{uniqueDifficulty.map(difficulty => difficultyNumberToTextMapping(difficulty)).join(',')}{' '}
										</span>
									</div>
								</div>

								<div className="mt-4 text-sm italic text-[#7777E7]">Questions may not be in the same order</div>

								{a
									?.sort((a, b) => Number(a?.question?.difficulty) - Number(b?.question?.difficulty))
									?.map(assessment => {
										const difficulty = difficultyNumberToTextMapping(assessment?.question?.difficulty);
										return (
											<Accordion
												key={assessment?.topicId}
												alwaysOpen={true}
												className="mt-[10px] overflow-hidden border !border-[#414247] text-white sm:mx-[10px]"
												collapseAll={true}
											>
												<Accordion.Panel key={assessment?.topicId}>
													<Accordion.Title
														color="white"
														className="accordion-title-main-container relative flex-row-reverse border !border-[#414247] text-[grey]"
														tabIndex={-1}
													>
														<div className="absolute left-[60px] top-0 flex h-[80%] w-[calc(100%-75px)] items-center justify-between gap-2 text-[grey]">
															<div className="flex items-center gap-4 gap-y-[3px] sm:flex-wrap md:gap-3">
																<div className="interview-round-title-div max-w-[400px] truncate text-base font-extrabold sm:max-w-[200px] sm:text-[13px] ">
																	Topic: <span className="font-medium">{assessment?.topicName}</span>
																</div>
																<div className="interview-round-title-div ml-8 max-w-[400px] truncate text-base font-extrabold sm:max-w-[200px] sm:text-[13px]">
																	Difficulty:
																	<span
																		className={classNames(
																			'interview-round-title-div ml-2 max-w-[400px] truncate text-base sm:max-w-[200px] sm:text-[13px]',
																			difficulty === QuestionDifficulty.Easy
																				? 'text-[#05A660]'
																				: difficulty === QuestionDifficulty.Medium
																				  ? 'text-[#E5B800]'
																				  : 'text-[#E53535]',
																		)}
																	>
																		{difficulty}
																	</span>
																</div>
															</div>
														</div>
													</Accordion.Title>
													<Accordion.Content className="border  !border-[#414247] ">
														{assessment?.question?.type === QuestionTypes.code ? (
															<>
																<div className="flex flex-col justify-start p-2">
																	<div className="font-extrabold">Question:</div>
																	{assessment?.question?.content.type === 'prepleaf-editor-raw-content' ? (
																		<div>
																			<StudentEditor readOnly={true} content={assessment?.question?.content?.body} />
																		</div>
																	) : (
																		<div
																			dangerouslySetInnerHTML={{
																				__html: assessment?.question?.content?.body
																					? `${assessment?.question?.content?.body}`
																					: 'No content!',
																			}}
																		/>
																	)}
																</div>
																<div className="flex flex-col justify-start p-2">
																	<div className="font-extrabold">Solution:</div>
																	{assessment?.question?.solution?.type === 'prepleaf-editor-raw-content' ? (
																		<div>
																			<StudentEditor
																				readOnly={true}
																				content={assessment?.question?.solution?.body}
																				key={1}
																			/>
																		</div>
																	) : (
																		<div
																			dangerouslySetInnerHTML={{
																				__html: assessment?.question?.solution?.body
																					? `${assessment?.question?.solution?.body}`
																					: 'No solution!',
																			}}
																		/>
																	)}
																</div>
																<div className="flex flex-col justify-start p-2">
																	<div className="font-extrabold">Hint:</div>
																	{assessment?.question?.hint?.type === 'prepleaf-editor-raw-content' ? (
																		<div>
																			<StudentEditor
																				readOnly={true}
																				content={assessment?.question?.hint?.body}
																				key={1}
																			/>
																		</div>
																	) : (
																		<div
																			dangerouslySetInnerHTML={{
																				__html: assessment?.question?.hint?.body
																					? `${assessment?.question?.hint?.body}`
																					: 'No hint!',
																			}}
																		/>
																	)}
																</div>
															</>
														) : (
															<div className="flex flex-col justify-start p-2">
																<div className="font-extrabold">Question:</div>
																{assessment?.question?.content?.type === 'prepleaf-editor-raw-content' ? (
																	<div>
																		<StudentEditor readOnly={true} content={assessment?.question?.content?.body} />
																	</div>
																) : (
																	<div className="flex justify-start">{assessment?.question?.content?.body}</div>
																)}
															</div>
														)}
													</Accordion.Content>
												</Accordion.Panel>
											</Accordion>
										);
									})}
							</div>
						)
					);
				})}
			</div>
		</div>
	);
};

export default ShowSampleAssessment;
